<template>
  <Popup
    :open="open"
    :width="500"
    :position="{ top: 45, left: 0 }"
    :z-index="10"
  >
    <div class="popup">
      <div class="title">
        <div class="left">搜索记录</div>
        <div class="right" @click="clearHistory">
          <i class="iconfont icon-shanchu3" />清空
        </div>
      </div>
      <div
        class="cell"
        :key="key"
        v-for="(item, key) in searchHistory"
        @click="handleCellClick(item, key)"
        :style="{
          marginBottom: key === searchHistory.length - 1 && '6px',
        }"
      >
        <div class="cell_left">
          <span class="label">
            {{ item.label }}
          </span>
          <span class="text">
            {{ item.text }}
          </span>
          <div class="tips">
            <!-- 选择地区 -->
            <span class="areas">
              <span
                v-if="
                  item.searchChoseParams.newAreas.tmpl &&
                  item.searchChoseParams.newAreas.tmpl[0] &&
                  item.searchChoseParams.newAreas.tmpl[0].text
                "
              >
                {{ item.searchChoseParams.newAreas.tmpl[0].text
                }}{{
                  item.searchChoseParams.newAreas.tmpl.length > 1 ? "..." : ""
                }}
              </span>
            </span>
            <div
              class="divider"
              v-if="
                item.searchChoseParams.allType &&
                item.searchChoseParams.allType.text
              "
            />
            <!-- 信息类型 -->
            <span class="allType">
              {{
                item.searchChoseParams.allType &&
                item.searchChoseParams.allType.text
                  ? item.searchChoseParams.allType.text.slice(0, 2) + "..."
                  : ""
              }}
            </span>
            <div
              class="divider"
              v-if="
                item.searchChoseParams.purchasingUnitIdList &&
                item.searchChoseParams.purchasingUnitIdList.tmpl &&
                item.searchChoseParams.purchasingUnitIdList.tmpl[0].text
              "
            />
            <!-- 采购单位 -->
            <span class="purchasingUnitIdList">
              <span
                v-if="
                  item.searchChoseParams.purchasingUnitIdList &&
                  item.searchChoseParams.purchasingUnitIdList.tmpl &&
                  item.searchChoseParams.purchasingUnitIdList.tmpl[0].text
                "
              >
                <span
                  v-if="
                    item.searchChoseParams.purchasingUnitIdList.tmpl[0].text.split(
                      '：'
                    ).length > 1
                  "
                >
                  {{
                    item.searchChoseParams.purchasingUnitIdList.tmpl[0].text
                      .split("：")[1]
                      .split(",")[0]
                  }}
                </span>
                <span v-else>{{
                  item.searchChoseParams.purchasingUnitIdList.tmpl[0].text.split(
                    "："
                  )[0]
                }}</span>
                <span
                  v-if="
                    item.searchChoseParams.purchasingUnitIdList.tmpl.length > 1
                  "
                  >...</span
                >
              </span>
            </span>
            <div
              class="divider"
              v-if="
                item.searchChoseParams.timeType &&
                (item.searchChoseParams.timeType.id === 9 ||
                  item.searchChoseParams.timeType.id === 1 ||
                  item.searchChoseParams.timeType.id === 4)
              "
            />
            <!-- 选择时间 -->
            <span class="timeType">
              <span v-if="item.searchChoseParams.timeType">
                <span
                  v-if="
                    item.searchChoseParams.timeType.id === 9 ||
                    item.searchChoseParams.timeType.id === 1 ||
                    item.searchChoseParams.timeType.id === 4
                  "
                >
                  <span v-if="item.searchChoseParams.timeType.id === 4">
                    {{ item.searchParams.beginTime }} -
                    {{ item.searchParams.endTime }}
                  </span>
                  <span v-else>{{ item.searchChoseParams.timeType.text }}</span>
                </span>
              </span>
            </span>
          </div>
        </div>
        <div class="cell_right" @click.stop="handleDelete(item, key)">
          <i class="iconfont icon-guanbi" />
        </div>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from "@/components/common/Popup";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";

export default {
  name: "PopupSearchHistory",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  components: { Popup },
  computed: {
    searchHistory() {
      return this.$store.getters["search/searchHistory"];
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.$track(DEED_MAP.EXPOSURE, OID_MAP.SEARCH_HISTORY_EXPOSURE);
      }
    },
  },
  methods: {
    // 删除一条历史
    handleDelete(value, index) {
      this.$emit("delete", { value, index });
    },
    // 历史记录点击
    handleCellClick(value, index) {
      this.$emit("cell", { value, index });
    },
    // 清空历史
    clearHistory() {
      this.$emit("clear");
    },
  },
};
</script>
<style scoped lang="scss" src="./popular&history.scss" />
